import { render, staticRenderFns } from "./ProductDesignFormEdit.vue?vue&type=template&id=3ff8f63c&"
import script from "./ProductDesignFormEdit.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports